<template>
    <b-field grouped>
        <p class="control">
            <scope-filter-dropdown
                :library="{ scopeType: scopeType }"
                :enable-row-selection="true" />
        </p>
        <p class="mt-1 is-size-5 has-text-weight-semibold">
            {{ scopeStore.selectedScope ? `Selected ${scopeType}: ${scopeStore.selectedScope}` : '' }}
        </p>
    </b-field>
</template>

<script>
    import { useScopeStore } from '@/stores/scopeStore.ts';
    import { mapStores } from 'pinia';
    import ScopeFilterDropdown from './ScopeFilterDropdown.vue';

    export default {
        components: {
            ScopeFilterDropdown
        },
        props: {
            scopeType: {
                type: String,
                default: null
            }
        },
        emits: [
            'update:selectedScope'
        ],
        computed: {
            ...mapStores(useScopeStore),
            scope: {
                get() {
                    return this.scopeStore.selectedScope;
                },
                set(newScope) {
                    this.scopeStore.updateSelectedScope(newScope);
                }
            }
        },
        watch: {
            scope(newScope) {
                this.$emit('update:selectedScope', newScope);
            }
        },
        async mounted() {
            if (this.scopeType !== null) {
                this.scopeStore.setScopeType(this.scopeType);
            }
            await this.scopeStore.init();
        }
    };
</script>
